import { goBot, cleanGistEvent, openNewBot } from './components/help';
global.goBot = goBot;
global.cleanGistEvent = cleanGistEvent;
global.openNewBot = openNewBot;
